import React from 'react'
import MediaBox from "./mediaBox";


function VidSources(props) {
  const vids = props.vids || [];
  const vidsOut = vids.map((vid,i) =>
    <source src={vid.src} key={i} type={vid.type} />
  );
  return vidsOut;
}


export default class Video extends React.Component {

  render() {
    return (
        <MediaBox>
          {typeof this.props.vid === 'string' && this.props.vid.indexOf('youtube') !== -1 &&
            <iframe src={this.props.vid} title="Teaser Video" style={{
              position: 'absolute',
              top: 0, left: 0,
              width: '100%',
              height: '100%'
            }} frameBorder={0} allow="autoplay; fullscreen; accelerometer; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
          }
          {typeof this.props.vid === 'object' &&
            <video controls style={{
              position: 'absolute',
              top: 0, left: 0,
              width: '100%',
              height: '100%'
            }}
            poster={this.props.poster}            
            >
              <VidSources vids={this.props.vid} />
            </video>
          }

        </MediaBox>
    )
  }
}
